import { Injectable } from '@angular/core';
import { ValidationStateService } from '@r1-compass-library/features/validation-sync';
import { TemplateCriteriaSectionName } from '@r1-compass-library/features/validation-sync';
import { AppConstants } from '../app.constants';

@Injectable({
    providedIn: 'root',
})
export class TemplateCriteriaValidationStateService extends ValidationStateService<TemplateCriteriaSectionName> {
    constructor() {
        super(AppConstants.TemplateCriteriaComponent.children);
    }
}
